// src/api/HorizonApi.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://matrix.gatik.ai/route_viewer/api",
  timeout: 60000,
});

export default api;
